import React, { useState } from 'react';
import { useLang } from '../../core/lang';
import LangKeys from '../../core/locales/keys';
import { X, Plus, Trash2, Check } from 'lucide-react';

const CustomFieldsModal = ({ isOpen, onClose, initialFields = [], onSave }) => {
  const { t } = useLang();
  const [fields, setFields] = useState(initialFields.length > 0 ? initialFields : [{ id: 1, label: '', value: '' }]);

  const handleAddField = () => {
    setFields([...fields, { id: Date.now(), label: '', value: '' }]);
  };

  const handleRemoveField = (id) => {
    setFields(fields.filter(f => f.id !== id));
  };

  const handleUpdate = (id, key, val) => {
    setFields(fields.map(f => f.id === id ? { ...f, [key]: val } : f));
  };

  if (!isOpen) return null;

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={e => e.stopPropagation()}>
        <div style={styles.header}>
           <h3 style={styles.title}>{t(LangKeys.add_bill_custom_fields)}</h3>
           <button style={styles.closeBtn} onClick={onClose}><X size={20} /></button>
        </div>
        
        <div style={styles.content}>
           {fields.map((field) => (
             <div key={field.id} style={styles.fieldRow}>
                <div style={styles.inputs}>
                   <input 
                     style={styles.input} 
                     placeholder="Label (e.g. Vehicle No.)" 
                     value={field.label} 
                     onChange={(e) => handleUpdate(field.id, 'label', e.target.value)} 
                   />
                   <input 
                     style={styles.input} 
                     placeholder="Value" 
                     value={field.value} 
                     onChange={(e) => handleUpdate(field.id, 'value', e.target.value)} 
                   />
                </div>
                <button style={styles.delBtn} onClick={() => handleRemoveField(field.id)}><Trash2 size={18} color="#EF4444" /></button>
             </div>
           ))}
           <button style={styles.addBtn} onClick={handleAddField}><Plus size={18} /> <span>ADD ANOTHER FIELD</span></button>
        </div>

        <div style={styles.footer}>
           <button style={styles.saveBtn} onClick={() => onSave(fields)}>
              <Check size={18} /> <span>SAVE FIELDS</span>
           </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000 },
  modal: { width: '100%', maxWidth: '500px', background: 'white', borderRadius: '24px', overflow: 'hidden', boxShadow: '0 20px 40px rgba(0,0,0,0.1)' },
  header: { padding: '20px 24px', borderBottom: '1px solid #F1F5F9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  title: { fontSize: '18px', fontWeight: '800', color: '#0F172A', margin: 0 },
  closeBtn: { border: 'none', background: 'transparent', cursor: 'pointer', color: '#94A3B8' },
  content: { padding: '24px', display: 'flex', flexDirection: 'column', gap: '16px' },
  fieldRow: { display: 'flex', alignItems: 'center', gap: '12px' },
  inputs: { flex: 1, display: 'flex', gap: '8px' },
  input: { flex: 1, height: '44px', padding: '0 12px', borderRadius: '10px', border: '1px solid #E2E8F0', background: '#F8FAFC', fontSize: '14px', fontWeight: '600', outline: 'none' },
  delBtn: { width: '44px', height: '44px', borderRadius: '10px', border: 'none', background: '#FEF2F2', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' },
  addBtn: { padding: '12px', borderRadius: '12px', border: '2px dashed #E2E8F0', background: 'transparent', color: '#1D4ED8', fontWeight: '800', fontSize: '13px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', cursor: 'pointer', marginTop: '8px' },
  footer: { padding: '16px 24px', background: '#F8FAFC', borderTop: '1px solid #F1F5F9' },
  saveBtn: { width: '100%', height: '48px', borderRadius: '12px', border: 'none', background: '#1D4ED8', color: 'white', fontWeight: '800', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', cursor: 'pointer' }
};

export default CustomFieldsModal;
